export interface AroundTheWorldEntry {
  name: string
  email: string
  termsAndConditions: false
}

export const initAroundTheWorld: AroundTheWorldEntry = {
  name: '',
  email: '',
  termsAndConditions: false,
}
